import React, {useContext, useEffect, useState} from "react";
import BackofficeContext from "../../../context/BackofficeContext";
import DropIcon from "../../icons/DropIcon";

function InputImageUpload (props) {
    const { image, type, classname, color, autocomplete, placeholder, forceBlur, focus, readonly, value, toUppercase, classError, newItem, handleChange, handleSubmit, handleBlur, handleKeyEnter, handleSearch, handleSelect } = props;
    const [ imageUploaded, setImageUploaded ] = useState(image);
    const [ step, setStep ] = useState(1);
    const [ loaderImport, setLoaderImport ] = useState(false);
    const { setBubbleText, setErrorText, setValidText } = useContext(BackofficeContext);
    const [ img, setImg ] = useState(null)
    const [ datas, setDatas ] = useState(null);
    const [ loader, setLoader ] = useState(false);
    const [ dragActive, setDragActive ] = useState(false);

    const getExtension = filename => {
        return filename.split(".").pop().toLowerCase();
    }
    const onChangeFile = (e) => {
        e.preventDefault();

        if (e.target.files && e.target.files[0]) {
            readUploadFile(e.target.files[0]);
        }
    }
    const readUploadFile = file => {

        if (datas === null)
            setLoader(true);

        if (!["jpg", "png"].includes(getExtension(file.name))) {
            setErrorText("le fichier sélectionné n'est pas pris en charge");
            setStep(1)
            setLoader(false);
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            const data = e.target.result;

            console.log("new file");
            console.log(data);

        };

        reader.readAsArrayBuffer(file);
    }
    const handleDrag = function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };
    const handleDrop = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            readUploadFile(e.dataTransfer.files[0]);
        }
    };

    return <form className={"form"} id={"form-file-upload"} onDragEnter={ handleDrag }>
        <input type={"file"} name={"file"} id="input-file-upload" onChange={ onChangeFile } />
        <label className={"inputFile" + (dragActive ? " dragActive" : "")} id="label-file-upload" htmlFor="input-file-upload">
            <div>
                <DropIcon/>
                <p className={"mainText"}>Cliquer ici ou déposer votre image</p>
                <p className={"secondaryText"}>Formats acceptés : .png, .jpg</p>
            </div>
        </label>
        {
            dragActive
            && <div id="drag-file-element" onDragEnter={ handleDrag } onDragLeave={ handleDrag } onDragOver={ handleDrag } onDrop={ handleDrop } />
        }
    </form>;

}

export default InputImageUpload;
